import FeatureSkeleton from '@woolworthslimited/core-components-react/skeleton/skeleton';
import React from 'react';

import styles from './cart-tiles-ghost.module.scss';

const skeletonHeight = 20;

const BaseCartTileGhostElement = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => {
  return (
    <FeatureSkeleton
      animation="wave"
      variant="rectangular"
      width={width}
      height={height}
      className={styles.borderRadius}
    />
  );
};

const CartTileGhost = () => {
  return (
    <div className={`${styles.tile}`}>
      <div className={`${styles.image}`}>
        <BaseCartTileGhostElement width={72} height={72} />
      </div>
      <div className={`${styles.details}`}>
        <BaseCartTileGhostElement width={200} height={skeletonHeight} />
        <BaseCartTileGhostElement width={80} height={skeletonHeight} />
      </div>
      <div className={`${styles.price}`}>
        <BaseCartTileGhostElement width={60} height={skeletonHeight} />
      </div>
      <div className={`${styles.note}`}>
        <BaseCartTileGhostElement width={115} height={skeletonHeight} />
      </div>
      <div className={`${styles.checkbox}`}>
        <BaseCartTileGhostElement width={110} height={skeletonHeight} />
      </div>
    </div>
  );
};

export const CartTilesGhost = ({ className }: { className?: string } = {}) => {
  return (
    <div className={className}>
      {Array.from({ length: 4 }).map((_, index) => {
        return (
          <React.Fragment key={index}>
            <CartTileGhost />
            <div data-testid="divider" className={styles.divider} />
          </React.Fragment>
        );
      })}
      <div className={styles.footer}>
        <BaseCartTileGhostElement width={193} height={48} />
        <BaseCartTileGhostElement width={179} height={48} />
      </div>
    </div>
  );
};
